import React, { useState } from "react";
import "./Header.css";
import logo from "../../assets/logo.png";
import Bars from "../../assets/bars.png";
// import { link } from "react-router-dom";

const Header = () => {
  const mobile = window.innerWidth <= 7687 ? true : false;
  const [menuOpened, setmenuOpened] = useState(false);
  return (
    <div className="header" id="Home">
      <img src={logo} alt="" className="logo" />

      {menuOpened === false && mobile === true ? (
        <div
          style={{
            backgroundColor: "var(--appColor)",
            padding: "0.5rem",
            borderRadius: "5px ",
          }}
          onClick={() => setmenuOpened(true)}
        >
          <img
            src={Bars}
            alt=""
            style={{ width: "1.5rem", height: "1.5rem" }}
          />
        </div>
      ) : (
        <ul className="header-menu">
          {/* <li>Home</li>
          <li>Programs</li>
          <li>Why Us</li>
          <li>Plans</li>
          <li>Testimonials</li> */}
          <a onClick={() => setmenuOpened(false)} href="#Home">
            Home
          </a>
          <a onClick={() => setmenuOpened(false)} href="#Programs">
            Programs
          </a>
          <a onClick={() => setmenuOpened(false)} href="#Why Us">
            Why Us
          </a>
          <a onClick={() => setmenuOpened(false)} href="#Plans">
            Plans
          </a>
          <a onClick={() => setmenuOpened(false)} href="#Testimonials">
            Testimonials
          </a>
        </ul>
      )}
    </div>
  );
};

export default Header;
